import React from 'react';
;
const PrimaryButton = ({ primaryBtnClassName, PrimaryBtnIcon, primaryBtnIconClassName, onClick, btnType, btnText, disabled, }) => (React.createElement("button", Object.assign({ className: primaryBtnClassName || '' }, (onClick && { onClick }), { type: btnType }, (disabled !== undefined && { disabled })),
    btnText,
    PrimaryBtnIcon && (React.createElement("span", { className: primaryBtnIconClassName || '' }, PrimaryBtnIcon))));
export default PrimaryButton;
//# sourceMappingURL=PrimaryButton.js.map